import angular from 'angular';

export const focusMe = () => ({
    link(scope, element, attrs) {
        scope.$watch(attrs.focusMe, (value) => {
            if (value === true) {
                element[0].focus();
                scope[attrs.focusMe] = false;
            }
        });
    },
});

angular
    .module('TALENYA-FE')
    .directive('focusMe', focusMe);
